import "./style.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./config/store";

import "./plugins/bootstrap-vue";
import "./plugins/axios";
import "./plugins/vuelidate";
import "./plugins/vue-session";
import "./plugins/vue-sidebar-menu";
import "./plugins/vue-filter-date-format";
import "./plugins/primevue";
import "./plugins/vue-moment";
import "./plugins/cpf";
import "./plugins/vuejs-countdown-timer";

Vue.config.productionTip = false;

new Vue({
	store,
	router,
	render: (h) => h(App),
}).$mount("#app");
